/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Careers_Pay_Per_WeekInputs */



/**
* | output |
* | --- |
* | "{amount} per week" |
*
* @param {Careers_Pay_Per_WeekInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_per_week = /** @type {((inputs: Careers_Pay_Per_WeekInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_Per_WeekInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`每周 ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.amount} per week`)
});